import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ContainerStyleService } from '../../../../../phf.service';

@Component({
    selector: 'style-window',
    templateUrl: './style.component.html',
    styleUrls: ['../../part-detail.component.scss']
})

export class StyleComponent implements OnInit {

    styleEditForm: FormGroup;
    part: any;
    public opened: boolean

    @Input()
    set data(editForm: FormGroup) {
        if (editForm) {
            this.part = editForm.value;
        }
    }

    @Output()
    save: EventEmitter<any> = new EventEmitter();
    @Output()
    close: EventEmitter<any> = new EventEmitter();

    constructor(
        private readonly formBuilder: FormBuilder,
        public readonly containerStyleService: ContainerStyleService
    ) {
        this.containerStyleService.read();
    }

    ngOnInit() {
        this.styleEditForm = this.formBuilder.group(StyleForm);
        this.styleEditForm.reset(this.part);
    }

    closeWindow() {
        this.close.emit();
        this.opened = false;
    }

    // Builds and passes OrientationNote value to the FirstOrientation editForm in PartLoading tab
    onSave() {
        this.save.emit(this.styleEditForm.get('Style').value);
    }

    onClicked = (dataItem, orientation) => {
        const ctrl = this.styleEditForm.get("Style");
        const styleDescription = this.containerStyleService.value.find(x => x.Id === dataItem);
        if (ctrl.value) {
            const orientationNote = ctrl.value.concat((styleDescription ? (' ' + styleDescription.Description) : '') + ',');
            ctrl.setValue(orientationNote);
        } else {
            ctrl.setValue((styleDescription ? styleDescription.Description : '') + ',');
        }
    }
}

const StyleForm = {
    Style: [],
}
